export default class NewsdicUpdateService {
  getAll() {
    return fetch("https://api.tradersr.com/api/newsdicupdate")
      .then(res => res.json());
  }
}